module.exports = __webpack_public_path__ + "media/images/cheil-7320d728fcdd32ad74e4be46e69bad0e.svg";